import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { onUnmounted, reactive, ref } from 'vue';

interface LabelOptions {
  map: google.maps.Map;
  position: google.maps.LatLng;
  skewed: boolean;
  label: string | number;
  div: () => HTMLDivElement;
}

interface Props {
  map: google.maps.Map;
  position: google.maps.LatLng;
  skewed?: boolean;
  label: string | number;
  fillColor?: string;
  textColor?: string;
  outline?: boolean;
  outlineColor?: string;
  fontWeight?: string | number;
  visible?: boolean;
  zIndex: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GoogleMapsLabel',
  props: {
    map: null,
    position: null,
    skewed: { type: Boolean, default: true },
    label: null,
    fillColor: { default: '#FFFFF' },
    textColor: { default: '#000000' },
    outline: { type: Boolean, default: true },
    outlineColor: { default: '#808080' },
    fontWeight: { default: 500 },
    visible: { type: Boolean, default: true },
    zIndex: null
  },
  setup(__props: any) {

const props = __props as { map: google.maps.Map, position: google.maps.LatLng, skewed: boolean, label: string | number, fillColor: string, textColor: string, outline: boolean, outlineColor: string, fontWeight: string | number, visible: boolean, zIndex: number }

_useCssVars((_vm, _setup) => ({
  "d7e802e2": (_vm.textColor),
  "e13dd80e": (_vm.fillColor),
  "9d7c3d12": (_setup.fontSize),
  "6ee2be6e": (_vm.fontWeight),
  "3c7eb548": (_vm.outlineColor)
}))

class Label extends google.maps.OverlayView {
  options: LabelOptions;

  constructor(options: LabelOptions) {
    super();
    this.options = options;
    this.setMap(options.map);
  }

  onAdd(): void {
    const div = this.options.div();
    if (div) {
      this.getPanes()?.markerLayer.appendChild(div);
    }
  }

  // optimize remove method
  onRemove(): void {
    const div = this.options.div();
    this.getPanes()?.markerLayer.removeChild(div);
  }

  draw(): void {
    const div = this.options.div();
    const divPosition = this.getProjection().fromLatLngToDivPixel(this.options.position);
    let x = divPosition?.x || 0;
    let y = divPosition?.y || 0;
    if (!this.options.skewed) {
      // label is centered on coordinates
      x -= div.offsetWidth / 2;
      y -= div.offsetHeight / 2;
    }

    div.style.left = `${x}px`;
    div.style.top = `${y}px`;
  }
}



const fontSize = ref<string>(`${estimateFontSize()}pt`);
const pill = ref<HTMLDivElement>();
const label = reactive<Label>(
  new Label({
    map: props.map,
    position: props.position,
    skewed: props.skewed,
    label: props.label,
    div: () => pill.value!,
  }),
);

/* LIFECYCLE */

props.map.addListener('zoom_changed', () => {
  fontSize.value = `${estimateFontSize()}pt`;
});

onUnmounted(() => {
  label.setMap(null);
});

/* METHODS */

function estimateFontSize(): number {
  const zoomLevel = (props.map.getZoom() || 11) - 10;
  return zoomLevel > 0 ? zoomLevel : 1;
}

return { __sfc: true,Label, props, fontSize, pill, label, estimateFontSize }
}

})